import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { AssignmentTurnedInOutlined } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';

export const ApprovedStepSection: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useStyles();

  return (
    <Box display="flex" flexDirection="column" flexGrow={1} justifyContent="center" >
      <Box
        display="flex" flexDirection="column"alignItems="center" mb={3} mt={{ xs: 5, sm: 0 }} ml={{ xs: 2, sm: 0 }} gap="16px"
      >
        <AssignmentTurnedInOutlined className={classes.icon}/>
        <Typography variant="h3" className={classes.dark}>
          {l10n.providerSettings.onboarding.allSet}
        </Typography>
        <Typography variant="h3" className={classes.purple}>
          {l10n.providerSettings.onboarding.liveOnUpliftSoon}
        </Typography>
        <Typography variant="h4">
          {l10n.providerSettings.onboarding.checkEmailAboutGoLiveDate}
        </Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()(theme => ({
  blue: {
    color: theme.palette.info.main,
  },
  dark: {
    color: theme.palette.primary.dark,
  },
  purple: {
    color: theme.palette.secondary.main,
  },
  icon: {
    fontSize: '4rem',
    color: theme.palette.text.secondary,
  },
}));
